import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import heroImage from './Slide3.jpeg';
import carImage from './Car.jpeg';

const PHONE_NUMBER = '+393429118790';
const HERO_ROTATION_DELAY = 10000;
const heroImages = [
  { src: heroImage, altKey: 'hero_imageAlt' },
  { src: carImage, altKey: 'hero_carImageAlt' },
];

const Slideshow = ({ id }) => {
  const { t } = useTranslation();
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setActiveImage((current) => (current + 1) % heroImages.length);
    }, HERO_ROTATION_DELAY);

    return () => window.clearInterval(interval);
  }, []);

  return (
    <section id={id} className="hero" aria-labelledby="hero-title">
      <div className="heroContent">
        <div className="heroCopy">
          <p className="heroEyebrow">{t('hero_eyebrow')}</p>
          <h1 id="hero-title">{t('hero_title')}</h1>
          <p className="heroDescription">{t('hero_description')}</p>

          <div className="heroActions">
            <a className="heroButton heroButtonPrimary" href={`tel:${PHONE_NUMBER}`}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M6.62 10.79a15.46 15.46 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.61 21 3 13.39 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2Z" />
              </svg>
              {t('hero_call')}
            </a>
            <a
              className="heroButton heroButtonSecondary"
              href={`https://wa.me/${PHONE_NUMBER.replace('+', '')}`}
              target="_blank"
              rel="noreferrer"
            >
              {t('hero_whatsapp')}
              <span aria-hidden="true">↗</span>
            </a>
          </div>

          <ul className="heroHighlights" aria-label={t('hero_benefitsLabel')}>
            <li><strong>24/7</strong><span>{t('hero_service')}</span></li>
            <li><strong>7</strong><span>{t('hero_passengers')}</span></li>
            <li><strong>3</strong><span>{t('hero_languages')}</span></li>
          </ul>
        </div>

        <div className="heroVisual">
          {heroImages.map((image, index) => (
            <img
              key={image.src}
              className={`heroImage${activeImage === index ? ' heroImageActive' : ''}`}
              src={image.src}
              alt={t(image.altKey)}
              aria-hidden={activeImage !== index}
            />
          ))}
          <div className="heroImageControls" aria-label={t('hero_imageControls')}>
            {heroImages.map((image, index) => (
              <button
                key={image.src}
                type="button"
                className={activeImage === index ? 'active' : ''}
                aria-label={t('hero_showImage', { number: index + 1 })}
                aria-pressed={activeImage === index}
                onClick={() => setActiveImage(index)}
              />
            ))}
          </div>
          <div className="heroImageBadge">
            <span className="heroBadgeDot" aria-hidden="true" />
            <span>{t('hero_badge')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Slideshow;
